import React, { useEffect, useState } from "react";
import { Loader } from "react-overlay-loader";
import { DatePicker, Button, Col, Row, Select, Input } from "antd";
import Datatable from "../../component/table/dataTable";
import request from "../../lib/requester";
import moment from "moment";
import formatCurency from "../../component/format/formatCurency";
import xlsx from "xlsx";
const { Option } = Select;
const { RangePicker } = DatePicker;

const FormMonitoringWHT = () => {
  const [isLoading, setIsloading] = useState(false);
  const [data, setData] = useState([]);
  const [dataDownload, setDataDownload] = useState([]);
  const [listPrincipal, setListPrincipal] = useState([]);
  const [listBranch, setListBranch] = useState([]);

  const [principal, setPrincipal] = useState("ALL");
  const [uploadByPrincipl, setUploadByPrincipal] = useState("ALL");
  const [branch, setBranch] = useState("ALL");
  const [claimNumber, setClaimNumber] = useState("");
  const [statusBupot, setStatusBupot] = useState("ALL");
  const [customerRefund, setCustomerRefund] = useState("ALL");
  const [selectedDate, setSelectedDate] = useState("");

  useEffect(() => {
    getPrincipal();
    getBranch();
  }, []);

  const search = async () => {
    setIsloading(true);
    const param = {
      principal_code: principal,
      is_principal: uploadByPrincipl,
      branch_code: branch,
      claim_number: claimNumber,
      bupot_status: statusBupot,
      customer_refund: customerRefund,
      start_date_submit_to_principal: selectedDate[0],
      end_date_submit_to_principal: selectedDate[1],
    };

    let url = "/api/traces/v1/report/monitoring-bukti-potong";
    await request.postTraces(url, param, {
      success: function (response) {
        const res = response.data.data;

        const maping = res.map((value, index) => {
          return {
            PRINCIPAL_CODE: value.PRINCIPAL_CODE,
            BRANCH: value.BRANCH,
            CLAIM_NUMBER: value.CLAIM_NUMBER,
            KWITANSI_NUMBER: value.KWITANSI_NUMBER,
            AWB_NO_CABANG_SUBMIT_DATE: value.AWB_NO_CABANG_SUBMIT_DATE
              ? moment(value.AWB_NO_CABANG_SUBMIT_DATE).format("DD MMMM YYYY")
              : value.AWB_NO_CABANG_SUBMIT_DATE,
            AWB_RECEIPT_DATE_HO: value.AWB_RECEIPT_DATE_HO
              ? moment(value.AWB_RECEIPT_DATE_HO).format("DD MMMM YYYY")
              : value.AWB_RECEIPT_DATE_HO,
            AWB_HO_SUBMIT_TO_PRINCIPAL: value.AWB_HO_SUBMIT_TO_PRINCIPAL
              ? moment(value.AWB_HO_SUBMIT_TO_PRINCIPAL).format("DD MMMM YYYY")
              : value.AWB_HO_SUBMIT_TO_PRINCIPAL,
            CUSTOMER_NAME: value.CUSTOMER_NAME,
            PROGRAM_TYPE: value.PROGRAM_TYPE,
            COVER_LETTER_NUMBER: value.COVER_LETTER_NUMBER,
            COVER_LETTER_DATE: value.COVER_LETTER_DATE
              ? moment(value.COVER_LETTER_DATE).format("DD MMMM YYYY")
              : value.COVER_LETTER_DATE,
            STATUS: value.STATUS,
            APPROVED_REJECTED_DATE: value.APPROVED_REJECTED_DATE
              ? moment(value.APPROVED_REJECTED_DATE).format("DD MMMM YYYY")
              : value.APPROVED_REJECTED_DATE,
            NILAI_DPP: formatCurency(value.NILAI_DPP),
            NILAI_PPN: formatCurency(value.NILAI_PPN),
            TOTAL_CLAIM: formatCurency(value.TOTAL_CLAIM),
            PPH_TYPE: value.PPH_TYPE,
            PPH_RATE: formatCurency(value.PPH_RATE),
            NILAI_PPH: formatCurency(value.NILAI_PPH),
            CLAIM_NET: formatCurency(value.CLAIM_NET),
            PAYMENT_DATE: value.PAYMENT_DATE
              ? moment(value.PAYMENT_DATE).format("DD MMMM YYYY")
              : value.PAYMENT_DATE,
            PAYMENT_AMOUNT: formatCurency(value.PAYMENT_AMOUNT),
            UPLOAD_BUPOT_BY_PRINCIPAL: value.UPLOAD_BUKPOT_BY_PRINCIPAL,
            EBUPOT_UPLOAD_BY: value.EBUPOT_UPLOAD_BY,
            EBUPOT_UPLOAD_DATE: value.EBUPOT_UPLOAD_DATE
              ? moment(value.EBUPOT_UPLOAD_DATE).format("DD MMMM YYYY")
              : value.EBUPOT_UPLOAD_DATE,
            EMAIL_DATE: value.EMAIL_DATE
              ? moment(value.EMAIL_DATE).format("DD MMMM YYYY")
              : value.EMAIL_DATE,
            EBUPOT_DOWNLOAD_BY: value.EBUPOT_DOWNLOAD_BY,
            EBUPOT_DOWNLOAD_DATE: value.EBUPOT_DOWNLOAD_DATE
              ? moment(value.EBUPOT_DOWNLOAD_DATE).format("DD MMMM YYYY")
              : value.EBUPOT_DOWNLOAD_DATE,
            NO_EBUPOT: value.NO_EBUKPOT,
            NPWP: value.NPWP,
            NPWP_NAME: value.NPWP_NAME,
            // NPWP_ADDRESS: value.NPWP_ADDRESS,
            NO_DOKUMEN_REF_BUPOT: value.NO_DOKUMEN_REF_BUKPOT,
            TARIF_BUPOT: formatCurency(value.TARIF_BUKPOT),
            NILAI_EBUPOT: formatCurency(value.NILAI_EBUKPOT),
            PERIODE_BUPOT: value.PERIODE_BUKPOT,
            TGL_FISIK_BUPOT: value.TGL_FISIK_BUKPOT
              ? moment(value.TGL_FISIK_BUKPOT).format("DD MMMM YYYY")
              : value.TGL_FISIK_BUKPOT,
            AR_INVOICE_NUMBER: value.AR_INVOICE_NUMBER,
            DUE_DATE_CUSTOMER_REFUND: value.DUE_DATE_CUSTOMER_REFUND
              ? moment(value.DUE_DATE_CUSTOMER_REFUND).format("DD MMMM YYYY")
              : value.DUE_DATE_CUSTOMER_REFUND,
            REFUND_TYPE: value.REFUND_TYPE,
            VERIFIED_REASON: value.VERIFIED_REASON,
            DM_OPEN_NUMBER: value.DM_OPEN_NUMBER,
            DM_OPEN_DATE: value.DM_OPEN_DATE
              ? moment(value.DM_OPEN_DATE).format("DD MMMM YYYY")
              : value.DM_OPEN_DATE,
            DM_OPEN_AMOUNT: formatCurency(value.DM_OPEN_AMOUNT),
            REFUND_DATE: value.REFUND_DATE
              ? moment(value.REFUND_DATE).format("DD MMMM YYYY")
              : value.REFUND_DATE,
            // REFUND_AMOUNT: formatCurency(value.REFUND_AMOUNT),
            DM_ADJUSTED_AMOUNT: formatCurency(value.DM_ADJUSTED_AMOUNT),
            SALDO: formatCurency(value.SALDO),
            STATUS_BUPOT: value.STATUS_BUKPOT,
          };
        });

        setDataDownload(res);
        setData(maping);
        setIsloading(false);
      },
      error: function (e) {
        setIsloading(false);
      },
    });
  };

  const getPrincipal = async () => {
    setIsloading(true);
    let url = "/api/traces/v1/general/list-principal";
    await request.getTraces(url, {
      success: function (response) {
        const res = response.data.data;
        setListPrincipal(res);
        setIsloading(false);
      },
      error: function (e) {
        setIsloading(false);
      },
    });
  };

  const getBranch = async () => {
    let url = "/api/traces/v1/general/list-cabang";
    setIsloading(true);
    await request.getTraces(url, {
      success: function (response) {
        const res = response.data.data;
        setListBranch(res);
        setIsloading(false);
      },
      error: function (e) {
        setIsloading(false);
      },
    });
  };

  const downloadToXlsx = () => {
    const maping = dataDownload.map((value, index) => {
      return {
        PRINCIPAL_CODE: value.PRINCIPAL_CODE,
        BRANCH: value.BRANCH,
        CLAIM_NUMBER: value.CLAIM_NUMBER,
        KWITANSI_NUMBER: value.KWITANSI_NUMBER,
        AWB_NO_CABANG_SUBMIT_DATE: value.AWB_NO_CABANG_SUBMIT_DATE
          ? new Date(
              moment(value.AWB_NO_CABANG_SUBMIT_DATE)
                .utc()
                .format("DD MMM YYYY")
            )
          : value.AWB_NO_CABANG_SUBMIT_DATE,
        AWB_RECEIPT_DATE_HO: value.AWB_RECEIPT_DATE_HO
          ? new Date(
              moment(value.AWB_RECEIPT_DATE_HO).utc().format("DD MMM YYYY")
            )
          : value.AWB_RECEIPT_DATE_HO,
        AWB_HO_SUBMIT_TO_PRINCIPAL: value.AWB_HO_SUBMIT_TO_PRINCIPAL
          ? new Date(
              moment(value.AWB_HO_SUBMIT_TO_PRINCIPAL)
                .utc()
                .format("DD MMM YYYY")
            )
          : value.AWB_HO_SUBMIT_TO_PRINCIPAL,
        CUSTOMER_NAME: value.CUSTOMER_NAME,
        PROGRAM_TYPE: value.PROGRAM_TYPE,
        COVER_LETTER_NUMBER: value.COVER_LETTER_NUMBER,
        COVER_LETTER_DATE: value.COVER_LETTER_DATE
          ? new Date(
              moment(value.COVER_LETTER_DATE).utc().format("DD MMM YYYY")
            )
          : value.COVER_LETTER_DATE,
        STATUS: value.STATUS,
        APPROVED_REJECTED_DATE: value.APPROVED_REJECTED_DATE
          ? new Date(
              moment(value.APPROVED_REJECTED_DATE).utc().format("DD MMM YYYY")
            )
          : value.APPROVED_REJECTED_DATE,
        NILAI_DPP: value.NILAI_DPP,
        NILAI_PPN: value.NILAI_PPN,
        TOTAL_CLAIM: value.TOTAL_CLAIM,
        PPH_TYPE: value.PPH_TYPE,
        PPH_RATE: value.PPH_RATE,
        NILAI_PPH: value.NILAI_PPH,
        CLAIM_NET: value.CLAIM_NET,
        PAYMENT_DATE: value.PAYMENT_DATE
          ? new Date(moment(value.PAYMENT_DATE).utc().format("DD MMM YYYY"))
          : value.PAYMENT_DATE,
        PAYMENT_AMOUNT: value.PAYMENT_AMOUNT,
        UPLOAD_BUPOT_BY_PRINCIPAL: value.UPLOAD_BUKPOT_BY_PRINCIPAL,
        EBUPOT_UPLOAD_BY: value.EBUPOT_UPLOAD_BY,
        EBUPOT_UPLOAD_DATE: value.EBUPOT_UPLOAD_DATE
          ? new Date(
              moment(value.EBUPOT_UPLOAD_DATE).utc().format("DD MMM YYYY")
            )
          : value.EBUPOT_UPLOAD_DATE,
        EMAIL_DATE: value.EMAIL_DATE
          ? new Date(moment(value.EMAIL_DATE).utc().format("DD MMM YYYY"))
          : value.EMAIL_DATE,
        EBUPOT_DOWNLOAD_BY: value.EBUPOT_DOWNLOAD_BY,
        EBUPOT_DOWNLOAD_DATE: value.EBUPOT_DOWNLOAD_DATE
          ? new Date(
              moment(value.EBUPOT_DOWNLOAD_DATE).utc().format("DD MMM YYYY")
            )
          : value.EBUPOT_DOWNLOAD_DATE,
        NO_EBUPOT: value.NO_EBUKPOT,
        NPWP: value.NPWP,
        NPWP_NAME: value.NPWP_NAME,
        // NPWP_ADDRESS: value.NPWP_ADDRESS,
        NO_DOKUMEN_REF_BUPOT: value.NO_DOKUMEN_REF_BUKPOT,
        TARIF_BUPOT: value.TARIF_BUKPOT,
        NILAI_EBUPOT: value.NILAI_EBUKPOT,
        PERIODE_BUPOT: value.PERIODE_BUKPOT,
        TGL_FISIK_BUPOT: value.TGL_FISIK_BUKPOT
          ? new Date(moment(value.TGL_FISIK_BUKPOT).utc().format("DD MMM YYYY"))
          : value.TGL_FISIK_BUKPOT,
        AR_INVOICE_NUMBER: value.AR_INVOICE_NUMBER,
        DUE_DATE_CUSTOMER_REFUND: value.DUE_DATE_CUSTOMER_REFUND
          ? new Date(
              moment(value.DUE_DATE_CUSTOMER_REFUND).utc().format("DD MMM YYYY")
            )
          : value.DUE_DATE_CUSTOMER_REFUND,
        REFUND_TYPE: value.REFUND_TYPE,
        VERIFIED_REASON: value.VERIFIED_REASON,
        DM_OPEN_NUMBER: value.DM_OPEN_NUMBER,
        DM_OPEN_DATE: value.DM_OPEN_DATE
          ? new Date(moment(value.DM_OPEN_DATE).utc().format("DD MMM YYYY"))
          : value.DM_OPEN_DATE,
        DM_OPEN_AMOUNT: value.DM_OPEN_AMOUNT,
        REFUND_DATE: value.REFUND_DATE
          ? new Date(moment(value.REFUND_DATE).utc().format("DD MMM YYYY"))
          : value.REFUND_DATE,
        DM_ADJUSTED_AMOUNT: value.DM_ADJUSTED_AMOUNT,
        SALDO: value.SALDO,
        STATUS_BUPOT: value.STATUS_BUKPOT,
      };
    });

    const workBook = xlsx.utils.book_new();
    const workSheet = xlsx.utils.json_to_sheet(maping, {
      dateNF: "DD MMM YYYY",
      cellDates: true,
    });
    xlsx.utils.book_append_sheet(workBook, workSheet, "Sheet1");
    xlsx.writeFile(
      workBook,
      `report-form-wht-${moment(new Date()).format("DDMMYYYYHHmmss")}.xlsx`,
      { cellDates: true }
    );
  };
  return (
    <div>
      <section className="content">
        <div className="container-fluid">
          <div className="row ml-1">
            <div className="col-lg-12">
              <div className="card card-info">
                <div className="card-header">Form Monitoring WHT</div>
                <div className="card-body">
                  <Row>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="col-md-12 col-form-label">
                          Principal
                        </label>
                        <div className="col-md-12">
                          <Select
                            style={{ width: "100%" }}
                            showSearch
                            placeholder="Search"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            onChange={(e) => setPrincipal(e)}
                            value={principal}
                            // defaultValue={selectedChanel}
                          >
                            <Option value={"ALL"}>All Principal</Option>
                            {listPrincipal.map((value, index) => {
                              return (
                                <Option
                                  key={value.org_id}
                                  value={value.org_initial}
                                >
                                  {value.org_name}
                                </Option>
                              );
                            })}
                          </Select>
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="col-md-12 col-form-label">
                          Uploaded by Principal
                        </label>
                        <div className="col-md-12">
                          <Select
                            style={{ width: "100%" }}
                            showSearch
                            placeholder="Search"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            onChange={(e) => setUploadByPrincipal(e)}
                            value={uploadByPrincipl}
                          >
                            <Option value={"ALL"}>All</Option>
                            <Option value={"YES"}>Yes</Option>
                            <Option value={"NO"}>No</Option>
                          </Select>
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="col-md-12 col-form-label">
                          Branch
                        </label>
                        <div className="col-md-12">
                          <Select
                            style={{ width: "100%" }}
                            showSearch
                            placeholder="Search"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            onChange={(e) => setBranch(e)}
                            value={branch}
                          >
                            <Option value={"ALL"}>All Branch</Option>
                            {listBranch.map((value, index) => {
                              return (
                                <Option
                                  key={value.org_id}
                                  value={value.org_name}
                                >
                                  {value.org_name}
                                </Option>
                              );
                            })}
                          </Select>
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="col-md-12 col-form-label">
                          AWB HO To Principal
                        </label>
                        <div className="col-md-12">
                          <RangePicker
                            style={{ width: "100%" }}
                            disabledDate={false}
                            allowClear={true}
                            onChange={(selectedDates, dateStr, instance) => {
                              setSelectedDate(dateStr);
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="col-md-12 col-form-label">
                          Claim Number
                        </label>
                        <div className="col-md-12">
                          <Input
                            value={claimNumber}
                            onChange={(e) => setClaimNumber(e.target.value)}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="col-md-12 col-form-label">
                          Status Bupot
                        </label>
                        <div className="col-md-12">
                          <Select
                            style={{ width: "100%" }}
                            showSearch
                            placeholder="Search"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            onChange={(e) => setStatusBupot(e)}
                            value={statusBupot}
                          >
                            <Option value={"ALL"}>All</Option>
                            <Option value={"OPEN"}>Open</Option>
                            <Option value={"CLOSE"}>Close</Option>
                          </Select>
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="col-md-12 col-form-label">
                          Customer Refund
                        </label>
                        <div className="col-md-12">
                          <Select
                            style={{ width: "100%" }}
                            showSearch
                            placeholder="Search"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            onChange={(e) => setCustomerRefund(e)}
                            value={customerRefund}
                          >
                            <Option value={"ALL"}>All</Option>
                            <Option value={"OPEN"}>Open</Option>
                            <Option value={"CLOSE"}>Close</Option>
                          </Select>
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="col-md-12 col-form-label"></label>
                        <div className="col-md-12 mt-3">
                          <Button
                            onClick={() => search()}
                            type="primary"
                            className="btn-block w-100"
                          >
                            Search
                          </Button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={24}
                      style={{
                        display: `${data.length ? "flex" : "none"}`,
                        justifyContent: "end",
                        marginBottom: "-40px",
                      }}
                    >
                      <Button
                        size="large"
                        onClick={() => downloadToXlsx()}
                        style={{ zIndex: 100 }}
                      >
                        download
                      </Button>
                    </Col>
                    <Col md={24}>
                      <Datatable
                        data={data}
                        filterButton={true}
                        // download={dataDownload}
                        addTittle={"Report Monitoring WHT"}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Loader fullPage loading={isLoading} />
    </div>
  );
};

export default FormMonitoringWHT;
